// Sprint 6-home-redesign: хиро-статус Главной («как я в целом»).
//
// HEAL-37: словарь приведён к общему. Красные — «Вне нормы» (их же показывает
// блок ниже, счётчик берётся из deriveAttention() — единый источник, G4).
// Оранжевые — свой столбец «Требуют внимания», как на карточке показателя.
// Сводка показывается ВСЕГДА (решение PM 05.10.2026). На чистом результате
// меняется только её заголовок — см. heroView.allNormal.

import { SummaryBarChart } from '@/components/dashboard/SummaryBarChart';
import { pluralize } from '@/lib/utils';
import { heroView } from '@/lib/homeAttention';
import type { DashboardSummary } from '@/api/types';

export function HeroStatus({
  summary,
  extrasCount,
  attentionCount,
  onUnknownClick,
  onAttentionClick,
}: {
  summary: DashboardSummary;
  extrasCount: number;
  /** Сколько показателей ВНЕ НОРМЫ (🔴) — из deriveAttention(), единый источник с блоком ниже. */
  attentionCount: number;
  // HEAL-30: колонка «Без оценки» ведёт в список с причиной по каждому показателю.
  onUnknownClick?: () => void;
  // HEAL-36: 🟠-столбец ведёт в «Маркеры» с отбором «Требуют внимания».
  onAttentionClick?: () => void;
}) {
  const { allNormal, inRange, unknown, total } = heroView(summary, extrasCount, attentionCount);

  return (
    <section className="px-4">
      <SummaryBarChart
        /* Решение PM 05.10.2026: сводка на Главной есть всегда, в том числе
           когда всё зелёное. Прежде на чистом результате столбики подменялись
           карточкой «Все показатели в норме», и человек терял и общее число,
           и раскладку. Похвала никуда не делась — она переехала в заголовок
           сводки, где не спорит с числами под собой. */
        title={allNormal ? 'Все показатели в норме' : 'Сводка'}
        total={total}
        normal={inRange}
        attention={summary.attention}
        outOfRange={attentionCount}
        unknown={unknown}
        totalUnit={pluralize(total, ['показатель', 'показателя', 'показателей'])}
        onUnknownClick={onUnknownClick}
        onAttentionClick={onAttentionClick}
      />
    </section>
  );
}
